
export default function Services() {
  return (
    <section id="services" className="py-24 bg-amber-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-8 mb-12">
          <div className="lg:w-2/5">
            <h2 className="text-5xl font-bold text-gray-900">Our VPN Services</h2>
          </div>
          <div className="lg:w-3/5">
            <p className="text-lg text-gray-700 leading-relaxed">
              DINARCO offers comprehensive VPN solutions designed to meet the security needs of individuals and businesses. Our advanced technology ensures your online activities remain private, secure, and unrestricted.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl p-10 text-white relative overflow-hidden">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-purple-500 to-blue-500"></div>
            
            <h3 className="text-3xl font-bold mb-8">Core VPN Features</h3>
            
            <div className="space-y-5">
              <div className="flex items-start space-x-4">
                <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-lg mb-1">Military-Grade Encryption</h4>
                  <p className="text-gray-300 text-sm">AES-256 bit encryption protects all your data</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-lg mb-1">No-Logs Policy</h4>
                  <p className="text-gray-300 text-sm">We never track or store your online activities</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-lg mb-1">Kill Switch Protection</h4>
                  <p className="text-gray-300 text-sm">Automatic protection if VPN connection drops</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-lg mb-1">Multi-Device Support</h4>
                  <p className="text-gray-300 text-sm">Protect all your devices simultaneously</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-lg mb-1">DNS Leak Protection</h4>
                  <p className="text-gray-300 text-sm">Prevents exposure of your browsing data</p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-purple-100 rounded-3xl p-8 flex items-start space-x-6">
              <div className="w-16 h-16 bg-purple-600 rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-speed-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Lightning-Fast Speeds</h3>
                <p className="text-gray-700 leading-relaxed">
                  Experience blazing-fast connection speeds with our optimized global server network. Stream, download, and browse without any slowdowns or buffering.
                </p>
              </div>
            </div>

            <div className="bg-blue-100 rounded-3xl p-8 flex items-start space-x-6">
              <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-earth-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Worldwide Access</h3>
                <p className="text-gray-700 leading-relaxed">
                  Connect to servers across multiple countries and continents. Access geo-restricted content and enjoy true internet freedom from anywhere in the world.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
